export enum EErrorMessages {
  DEFAULT = 'Oops... something went wrong',
  WRONG_JOB_NAME_SYMBOLS = `Job names must not include special characters (/, #, ?, <, >, \\, :, *, |, and ") or <a href="https://en.wikipedia.org/wiki/Filename#Reserved_characters_and_words" target="_blank" class="underline">reserved filenames</a>`,
  JOB_NAME_IS_TOO_LONG = `Job name is too long`,
  JOB_NAME_ENDS_WITH_SPACE = `Job name should not end with a space`,
  JOB_NAME_STARTS_WITH_SPACE = `Job name should not start with a space`,
  UNABLE_TO_DOWNLOAD = `Unable to download the file`,
}
